import cardValidator from 'card-validator';

export default cardValidator;

export * from 'card-validator';
